//Font actionTypes (For DMS object)
import { Font, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum FontActionTypes {
    AddFonts = "ADD_FONTS",
    ModifyFonts = "MODIFY_FONTS",
    DeleteFonts = "DELETE_FONTS",
}

/**
 * An action interface for adding an array of dmses to a state.
 */
export interface AddFonts extends Action{
    type: FontActionTypes.AddFonts;
    fonts: Font[];
}

/**
 * An action interface for modifying an array of dmses existing on a state.
 */
export interface ModifyFonts extends Action{
    type: FontActionTypes.ModifyFonts;
    fonts: Font[];
}

/**
 * An action interface for deleting an array of dmses existing on a state.
 */
export interface DeleteFonts extends Action{
    type: FontActionTypes.DeleteFonts;
    ids: Id[];
}